import Vue from 'vue'
import Vuex from 'vuex'
import UserModule from './user'
import OtherModule from './other'
import DocModule from './doc'
import AcceuilModule from './acceuil'
import FonctModule from './fonct'
import ServiceModule from './service'
import ReferenceModule from './reference'
import CaptureModule from './capture'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        user: UserModule,
        other: OtherModule,
        doc: DocModule,
        acceuil: AcceuilModule,
        fonct: FonctModule,
        service: ServiceModule,
        reference: ReferenceModule,
        capture: CaptureModule
    }
})
